import { useCallback } from 'react';

import { usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { useAppSelector } from 'app-components/hooks/redux';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { tracker } from 'app-components/utils/core';

import { useGlobalHotKey } from 'containers/GlobalHotKeys';
import showConfirmationDialog from 'components/Dialogs/ConfirmationDialog/show';

const PrivacyModeHotKeys = () => {
  const [sPrivacyMode, setSPrivacyMode] = usePreferenceV2('sPrivacyMode');
  const privacyMode = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'privacyMode'));

  const onTogglePrivacyMode = useCallback(() => {
    if (privacyMode) {
      if (sPrivacyMode) {
        showConfirmationDialog({
          title: 'Switch off Privacy mode?',
          content: 'With privacy mode off, actual dollar amounts will become visible in Simplifi.',
          confirmLabel: 'Switch off',
          confirmAction: () => {
            setSPrivacyMode(false);
            tracker.track(tracker.events.privacyMode, { state: false, location: 'PrivacyModeHotKeys' });
          },
        });
      } else {
        setSPrivacyMode(true);
        tracker.track(tracker.events.privacyMode, { state: true, location: 'PrivacyModeHotKeys' });
      }
    }
  }, [privacyMode, sPrivacyMode, setSPrivacyMode]);

  useGlobalHotKey({
    description: 'Toggle Privacy Mode',
    shiftKey: true,
    altKey: true,
    code: 'KeyP',
    callback: onTogglePrivacyMode,
  });

  return null;
};
export default PrivacyModeHotKeys;
